import React, { useEffect, useRef } from "react"
import isNumeric from "validator/lib/isNumeric"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { getUserList } from "services"
import { Select } from "components"
import { formatMobilePhone } from "utils"
import classes from "./RrhAccessSelect.module.scss"

const RrhAccessSelect = props => {
  const { filter, setFilter } = props

  const [t, i18n] = useTranslation()

  const timeout = useRef(null)

  const handleSelect = (select) => {
    setFilter(prev => ({
      ...prev,
      addedByAccount: select
    }))
  }

  const handleSearch = (inputValue, callback) => {
    clearTimeout(timeout.current)

    timeout.current =
      setTimeout(async () => {
        const queries = { role: "access", limit: 5 }

        if (isNumeric(inputValue)) {
          queries.mobilePhone =
            inputValue[0] === "0"
              ? inputValue.substring(1)
              : inputValue
        } else {
          queries.fullName = inputValue

          queries.username = inputValue
        }

        const { data: users } =
          await getUserList(queries)

        callback(
          users.map(user => ({
            label: `${user.fullName} ${user.mobilePhone ? `(${formatMobilePhone(user.mobilePhone)})` : ""}`,
            value: user._id
          }))
        )
      }, 600)
  }

  useEffect(() => {
    return () => {
      clearTimeout(timeout.current)
    }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Select
      async
      isClearable
      label={t("جست_و_جو_طریق_سفارش")}
      loadOptions={handleSearch}
      value={filter.addedByAccount}
      noOptionsMessage={() => null}
      onChange={handleSelect}
      className={clsx(
        classes["input"],
        isLtr && classes["input-ltr"]
      )}
    />
  )
}

export default RrhAccessSelect